/* eslint-disable security/detect-object-injection */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/function-component-definition */
import { FC, memo, useState } from "react";
import { FormikProps, getIn } from "formik";
import {
  CreateLeadsDetails,
  documentsTypes
} from "src/helpers/FormDetails/CreateDetails/interfaces";
import CustomBoxModal from "src/shared/CustomModalBox";
import UploadDocument from "src/shared/UploadDocument";
import { Button } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
// import Resources from "src/config/Resources";
import { RxCrossCircled } from "react-icons/rx";
import { ImCheckmark } from "react-icons/im";
import store from "src/redux/store";
import { SET_TOAST_ERROR } from "src/redux/Actions/common";
import CustomSelect from "../../CustomSelect";

interface Props {
  className?: string;
  formik: FormikProps<CreateLeadsDetails>;
  docIndex: number;
  acceptedFiles?: string[];
  maxFileSize?: number;
}

const UploadDocumentWithType: FC<Props> = ({
  formik,
  docIndex,
  acceptedFiles = [".pdf", ".jpg", ".jpeg", ".wav"],
  maxFileSize = 5 * 1024 * 1024
}) => {
  const [mefFile, setMefFile] = useState<File | null>(null);
  const [showCustomModal, setShowCustomModal] = useState(false);

  const isFileValid = (file: File | null): boolean => {
    if (!file) return false;
    if (file.size > maxFileSize) {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "error",
          message: `File size must be less than ${Math.round(maxFileSize / (1024 * 1024))}MB`
        })
      );
      return false;
    }
    const ext = `.${file.name.split(".").pop()?.toLowerCase()}`;
    if (acceptedFiles && !acceptedFiles.includes(ext)) {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "error",
          message: "Unsupported file type"
        })
      );
      return false;
    }
    return true;
  };

  const handleMEFUpload = () => {
    if (!mefFile) return;
    if (!isFileValid(mefFile)) return;
    formik.setFieldValue(`files.[${docIndex}].file`, mefFile);
    setShowCustomModal(false);
  };

  const handleRemoveClick = () => {
    const filteredfiles = formik.values?.files?.filter((_, index) => index !== docIndex);
    formik?.setFieldValue("files", filteredfiles);
  };

  const handleUploadClick = () => {
    setShowCustomModal(true);
  };

  return (
    <div className="flex justify-items-center overflow-auto max-h-96">
      {showCustomModal && (
        <CustomBoxModal
          onClose={() => {
            setShowCustomModal(false);
          }}
        >
          <div>
            <UploadDocument
              className="w-64 md:w-105"
              title="Upload File"
              description={mefFile?.name ? mefFile?.name : "Click to select or drag and drop"}
              supportedFileText={`Supported: ${acceptedFiles.join(", ")} (Max ${Math.round(
                maxFileSize / (1024 * 1024)
              )}MB)`}
              setFile={(value) => {
                const file = typeof value === "function" ? value(mefFile) : value;
                if (file && !isFileValid(file)) {
                  setMefFile(null);
                  return;
                }
                setMefFile(file);
              }}
              acceptedFiles={acceptedFiles}
            />
          </div>
          <div className="text-center px-4 my-2">
            <Button
              disabled={!mefFile || !isFileValid(mefFile)}
              variant="contained"
              onClick={handleMEFUpload}
              className="!capitalize h-10 w-32 rounded-lg"
            >
              Submit
            </Button>
          </div>
        </CustomBoxModal>
      )}
      <div className="space-y-2 flex space-x-3 justify-center flex-col lg:flex-row">
        <div className="lg:w-52">
          <CustomSelect
            requiredStar
            label="Document Type"
            options={Object.values(documentsTypes)}
            onChange={formik?.handleChange}
            setFieldTouched={formik?.setFieldTouched}
            name={`files.[${docIndex}].documentType`}
            value={formik?.values?.files?.[docIndex]?.documentType || ""}
            error={getIn(formik?.errors, `files.[${docIndex}].documentType`)}
            touched={getIn(formik?.touched, `files.[${docIndex}].documentType`)}
          />
        </div>
        <div className="flex space-x-1">
          <div>
            <Button
              disabled={!formik?.values?.files?.[docIndex]?.documentType}
              onClick={handleUploadClick}
              variant="contained"
              className="!uppercase rounded-lg"
            >
              <FileUploadOutlinedIcon className="cursor-pointer" />
              select
            </Button>
          </div>
          {formik?.values?.files?.[docIndex]?.file?.name && (
            <div className="!pt-3">
              <ImCheckmark className="!text-green-600" />
            </div>
          )}
        </div>
      </div>
      {formik?.values?.files?.length! > 1 && (
        <div className="my-auto">
          <Button
            onClick={handleRemoveClick}
            classes={{ root: "!px-0" }}
            disableRipple
            className="!text-black !uppercase my-0 h-10 w-10 !rounded-lg"
          >
            {/* <img src={Resources.images.FormDetails.removeIcon} alt="remove" /> */}
            <RxCrossCircled className="!text-hotShot" />
          </Button>
        </div>
      )}
    </div>
  );
};

UploadDocumentWithType.defaultProps = {
  className: "",
  acceptedFiles: [".pdf", ".jpg", ".jpeg", ".wav"],
  maxFileSize: 5 * 1024 * 1024
};

export default memo(UploadDocumentWithType);
